export default __webpack_public_path__ + "static/media/xbox.d46d8ee5.png";